import { render, staticRenderFns } from "./FooterServicePrivacy.vue?vue&type=template&id=70a06be2&scoped=true&"
import script from "./FooterServicePrivacy.vue?vue&type=script&lang=ts&"
export * from "./FooterServicePrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./FooterServicePrivacy.vue?vue&type=style&index=0&id=70a06be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a06be2",
  null
  
)

export default component.exports